/**
 * グルメ・おみやげ特集の初期化
 */
export function initGourmetFeatures($) {
  if ($('.s-gourmet-features').length === 0) return;

  // スライドボタン位置を動的に調整する汎用関数
  function adjustSlideButtonPosition(selector, itemSelector, figureSelector) {
    const $slide = $(selector);
    const $item = $slide.find(itemSelector).first();

    if ($item.length > 0) {
      // figure要素の高さを直接取得
      const $figure = $item.find(figureSelector);
      const figureHeight = $figure.length > 0 ? $figure.outerHeight() : 0;

      // ボタンサイズ（スマホ: 44px, PC: 54px）
      const buttonSize = window.innerWidth >= 768 ? 54 : 44;
      // ボタンの中心を画像の中心に配置
      const buttonTop = figureHeight / 2 - buttonSize / 2;
      console.log('Gourmet Features Button Position Debug:', {
        selector,
        figureHeight,
        buttonSize,
        buttonTop,
        windowWidth: window.innerWidth
      });

      // !important を上書きするため、each で直接 style 属性を操作
      $slide.find('.slick-prev, .slick-next').each(function () {
        // this.style.setProperty('top', buttonTop + 'px', 'important');
        // this.style.setProperty('transform', 'translateY(0%)', 'important');
        // this.style.setProperty('margin-top', '0', 'important');
      });
    }
  }

  // おすすめ店舗スライドのボタン位置を動的に調整
  function adjustGourmetSpotsButtonPosition() {
    // adjustSlideButtonPosition('.s-gourmet-features__contents--spots .c-slide', '.c-slide__item', '.c-slide__figure');
  }

  $('.s-home__features--slide').slick({
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '0',
    infinite: true,
    arrows: true,
    dots: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
          variableWidth: true,
        },
      },
    ],
  });

  // おすすめ店舗スライド
  // $('.s-gourmet-features__contents--spots .c-slide')
  //   .slick({
  //     slidesToShow: 2,
  //     slidesToScroll: 2,
  //     infinite: true,
  //     arrows: true,
  //     dots: true,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //         },
  //       },
  //     ],
  //   })
  //   .on('init reInit', function () {
  //     // slick初期化完了後に位置調整
  //     setTimeout(adjustGourmetSpotsButtonPosition, 100);
  //   });

  // 画像読み込み完了を待って位置調整
  const $gourmetSpotsImages = $('.s-gourmet-features__contents--spots .c-slide__figure img');
  let loadedCount = 0;
  const totalImages = $gourmetSpotsImages.length;

  if (totalImages > 0) {
    $gourmetSpotsImages.each(function () {
      if (this.complete && this.naturalHeight !== 0) {
        loadedCount++;
      } else {
        $(this).on('load', function () {
          loadedCount++;
          if (loadedCount === totalImages) {
            adjustGourmetSpotsButtonPosition();
          }
        });
      }
    });

    // すでに読み込み済みの場合
    if (loadedCount === totalImages) {
      adjustGourmetSpotsButtonPosition();
    }
  } else {
    // 画像がない場合は即座に調整
    adjustGourmetSpotsButtonPosition();
  }

  // ウィンドウリサイズ時にボタン位置を再調整
  $(window).on('resize', function () {
    adjustGourmetSpotsButtonPosition();
  });
}
